import { StringSchema } from 'yup';

export default function name(this: StringSchema, message: string) {
  return this.test('name', message, (value) => {
    const nameRegularExpression =
      /^(([a-zà-ÿA-ZÀ-Ÿ]{2,}){1}(\s([a-zà-ÿA-ZÀ-Ÿ]{1,}))+)\s*$/im;

    const schema = this.min(4, '')
      .max(255, '')
      .matches(nameRegularExpression, '');

    return schema.isValidSync(value);
  });
}
